import { __decorate } from "tslib";
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { elements } from './sdb-elements.js';
/**
 * Context menu element, used to wrap contextmenu-items
 *
 * @slot - Unnamed slot (default slot)
 *
 * @prop {String} light - optional, used to display the icon in the theme-light color (default white)
 */
let SDBContentContextMenu = class SDBContentContextMenu extends LitElement {
    constructor() {
        super(...arguments);
        this.light = false;
    }
    render() {
        return html `
            <ul class="contextMenuWrapper">
                <li class="contextMenu">
                    <sdb-content-icon
                        size="25"
                        icon="fal fa-ellipsis-vertical"
                    ></sdb-content-icon>
                    <ul id="toggleMenu">
                        <slot></slot>
                    </ul>
                </li>
            </ul>
        `;
    }
};
SDBContentContextMenu.styles = [
    elements,
    css `
            :host([light]) sdb-content-icon {
                color: var(--text-light);
            }

            a,
            li {
                color: #6b6b6b;
                text-decoration: none;
            }

            .contextMenuWrapper {
                display: inline-block;
                width: auto;
                padding: 0;
                margin: 0;
            }
            .contextMenuWrapper > li {
                display: inline-block;
                cursor: pointer;
            }
            .contextMenu {
                position: relative;
            }
            .contextMenu ul {
                position: absolute;
                left: 0;
                top: 1.5em;
                transition: scale 0.3s ease;
                transform: scale(0.01);
                -webkit-transform: rotateZ(360deg);
                transform-origin: 0 0;
                box-shadow:
                    0 1px 3px rgba(0, 0, 0, 0.12),
                    0 1px 2px rgba(0, 0, 0, 0.24);
                background: white;
                padding: 5px;
                z-index: 999;
                min-width: 200px;
            }
            .contextMenu:hover ul {
                transform: scale(1);
            }
        `,
];
__decorate([
    property({ type: Boolean })
], SDBContentContextMenu.prototype, "light", void 0);
SDBContentContextMenu = __decorate([
    customElement('sdb-content-contextmenu')
], SDBContentContextMenu);
export { SDBContentContextMenu };
//# sourceMappingURL=sdb-content-contextmenu.js.map